






































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

import { mapActions } from 'vuex';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';
import Button from '@/components/Button.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';

import api from '@/libs/api';
import store from '@/store';
import { ActionTypes, MutationTypes } from '@/store/disbursement';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Accordion from '@/components/Accordion.vue';
import FormInput from '@/components/FormInput.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import ReportTable from './OtherBusinessReportTable.vue';

@Component({
  components: {
    LayoutTitle,
    Button,
    LayoutContent,
    Tab,
    ReportTable,
    Accordion,
    SearchIcon,
    ExportIcon,
    SearchRow,
    SearchField,
    DatePicker,
    Select,
    FormInput,
  },
  methods: mapActions({ getBalance: ActionTypes.GET_DISBURSEMENT_BALANCE }),
})
export default class AccountStatement extends Vue {
  getBalance!: (merchantCode: string) => void;

  $refs!: {
    report: ReportTable;
  }

  searchOpen = false;
  showFeeSharing = false;

  date: DateRange = {
    startDate: null,
    endDate: null,
  }

  transactionTypeOptions = [
    { label: 'TRANSACTION', value: 'TRANSACTION' },
    { label: 'TOPUP', value: 'TOPUP' },
    // { label: 'ALL TYPE', value: 'ALL' },
  ];

  businessNameOptions: LabelValue[] = [];
  brandNameOptions: LabelValue[] = [];

  transactionType: LabelValue | null = null;
  businessName: LabelValue | null = null;
  brandName: LabelValue | null = null;
  merchantCode = '';

  token = '';
  transactionId = '';

  statusOptions = [
    { label: 'SUCCESS', value: 'SUCCESS' },
    { label: 'PENDING', value: 'PENDING' },
    { label: 'REFUND', value: 'REFUND' },
    { label: 'CANCELED', value: 'CANCELED' },
    // { label: 'ALL STATUS', value: 'ALL' },
  ];

  status: { label: string; value: string } | null = null;

  loadingExport = false;

  mounted() {
    store.commit(MutationTypes.SET_DISBURSEMENT_BALANCE, {
      total: 0,
      pending: 0,
      active: 0,
    });
    store.commit(MutationTypes.SET_DISBURSEMENT_BALANCE_LOADING, false);
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
    this.parseParams();
    this.getBusinessList();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getBusinessList() {
    const { data } = await api.get(`/disbursement/merchant-reseller/${this.$store.state.user.user.merchant.merchant_code}`, {
      headers: {
        token: this.token,
      },
    });
    data.merchants_reseller.forEach((d: any) => {
      this.businessNameOptions.push({
        label: d.name,
        value: d.merchant_code,
      });
      if (d.brand) {
        this.brandNameOptions.push({
          label: d.brand,
          value: d.merchant_code,
        });
      }
    });
    this.showFeeSharing = data.show_fee_sharing_merchant;
  }

  async getTransaction(page: number) {
    if (this.merchantCode !== '') {
      // store.commit(MutationTypes.SET_DISBURSEMENT_MERCHANT_CODE, this.merchantCode);
      this.getBalance(this.merchantCode);
      // store.commit(MutationTypes.SET_DISBURSEMENT_MERCHANT_CODE, '');
    }

    const params = {
      date: this.date,
      status: this.status,
      type: this.transactionType,
      id: this.transactionId,
      export: this.loadingExport,
    };

    return this.$refs.report.getTransaction(params, page, this.merchantCode);
  }

  async exportAccountStatement() {
    this.loadingExport = true;
    if (this.businessName !== null) {
      this.merchantCode = this.businessName?.value;

      showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

      try {
        const path = await this.getTransaction(1);
        this.downloadSheet(path as string);
        showToast(ToastType.SUCCESS, 'Success', 'Export merchant account state success');
      } catch (err) {
        showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to download sheet');
      }
    } else {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Please select business first');
    }
    this.loadingExport = false;
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(url: string) {
    const fileLink = document.createElement('a');
    fileLink.href = `${process.env.VUE_APP_API_URL}${url}`;
    fileLink.setAttribute('download', 'report.xlsx');

    document.body.appendChild(fileLink);
    fileLink.click();
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.date === 'string') {
      const dates = params.date.split(',');
      this.date = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    }

    if (typeof params.status === 'string') {
      const status = {
        label: params.status,
        value: params.status,
      };

      this.status = status;
    } else {
      this.status = null;
    }

    if (typeof params.type === 'string') {
      const status = {
        label: params.type,
        value: params.type,
      };

      this.transactionType = status;
    } else {
      this.transactionType = null;
    }

    if (typeof params.id === 'string') {
      const { id } = params;
      this.transactionId = id;
    } else {
      this.transactionId = '';
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    if (typeof params.merchant_code === 'string') {
      this.merchantCode = params.merchant_code;
    }

    this.getTransaction(page);
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  search() {
    const date = this.date.startDate === null || this.date.endDate === null ? undefined : {
      start: dayjs(this.date.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.date.endDate).format('YYYY-MM-DD'),
    };

    this.$router.push({
      query: {
        date: date && `${date.start},${date.end}`,
        type: this.transactionType === null ? undefined : this.transactionType.value,
        status: this.status === null ? undefined : this.status.value,
        id: this.transactionId === '' ? undefined : this.transactionId,
        // eslint-disable-next-line @typescript-eslint/camelcase
        merchant_code: this.businessName?.value,
      },
    });
  }

  cancel() {
    this.date = {
      startDate: null,
      endDate: null,
    };
    this.status = null;
    this.transactionType = null;
    this.transactionId = '';

    this.$router.push({
      query: {},
    });
  }
}
